export default __webpack_public_path__ + "static/media/USRenewableSolutions.2da7dd43.png";